import { CryptoIcon } from '@valiant/ui-shared'
import type { QuoteDisplayProps } from './types'

export function QuoteDisplay({
  quote,
  toMint,
  fromMint,
  countdown,
  isLoading,
  retryAt,
}: QuoteDisplayProps) {
  if (isLoading) {
    return (
      <div className="border-2 border-gray-200 rounded-lg p-3 flex items-center justify-center">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-main"></div>
        <span className="ml-2 text-gray-500">Getting quote...</span>
      </div>
    )
  }

  if (!quote) {
    return (
      <div className="border-2 border-gray-200 rounded-lg p-3 text-center text-gray-500">
        {retryAt ? 'Quote temporarily unavailable. Retrying shortly.' : 'Unable to get quote'}
      </div>
    )
  }

  return (
    <>
      <div className="border-2 border-gray-900 rounded-lg p-3 flex items-center gap-3">
        {toMint && (
          <CryptoIcon
            symbol={toMint.symbol}
            imageOverride={toMint.image || undefined}
            className="w-8 h-8"
          />
        )}
        <div className="flex-1">
          <span className="text-2xl font-bold">
            {parseFloat(quote.toAmount).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 6,
            })}
          </span>
          <div className="text-sm text-gray-600 mt-1">
            <div>
              Rate: 1 {fromMint?.symbol} ={' '}
              {parseFloat(quote.exchangeRate).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 6,
              })}{' '}
              {toMint?.symbol}
            </div>
          </div>
        </div>
      </div>
      <p className="text-sm text-gray-500 text-center mt-1">Quote expires in {countdown} seconds</p>
    </>
  )
}
